import { format, isValid, parseISO, type Locale } from 'date-fns';

/**
 * A record's date as the E57 tables show it. A value the browser cannot read (an old row with a malformed or epoch date)
 * shows a dash instead of throwing `RangeError: Invalid time value` mid-render, which would take the whole table down
 * (review suspect 5).
 */
export const formatDay = (iso: string | null | undefined, pattern: string, locale: Locale): string => {
  if (!iso) return '—';
  const d = parseISO(iso);
  return isValid(d) ? format(d, pattern, { locale }) : '—';
};
